export default "__VITE_ASSET__G8qi_1AL__"